import { format, fromUnixTime, getUnixTime } from 'date-fns'

export let dateToTs = function (dt) {
  return getUnixTime(dt)
}

export let formatUnixTimestamp = function (ts, datepicker = false) {
  var dateFormat = 'MMMM do, yyyy h:mm a'
  if (datepicker) {
    dateFormat = "yyyy-MM-dd'T'HH:mm"
  }
  return format(fromUnixTime(ts), dateFormat)
}

// JS Dates are automatically converted to local timezone
export let formatDate = function (dateStr, options = {}) {
  var dateFormat = 'M/d/yyyy'
  var timeFormat = 'h:mmaaaaa'
  var localDate = new Date(dateStr)
  var o = {
    showDate: true,
    showTime: true,
    formatStr: null,
  }

  // Apply option overrides
  Object.assign(o, options)

  // If formatStr given, just use that. Otherwise, use easy options
  if (!o.formatStr) {
    o.formatStr = dateFormat + ' ' + timeFormat

    // Only showing date or time.
    if (o.showDate && !o.showTime) {
      o.formatStr = dateFormat
    } else if (!o.showDate && o.showTime) {
      o.formatStr = timeFormat
    }
  }

  return format(localDate, o.formatStr)
}

export let formatDatepicker = function (dateStr, options = {}) {
  let dt = new Date(`${dateStr} MDT`)
  return dt.toISOString()
}

export let formatDateForDb = function (dateStr, options = {}) {
  var dateFormat = "yyyy-MM-dd'T'hh:mm:ss'Z'"
  var localDate = new Date(dateStr)

  return format(localDate, dateFormat)
}

export let formatInt = function (price) {
  return Math.round(price * 100)
}

export let formatPrice = function (price, hideDecimals) {
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })

  if (hideDecimals) {
    return formatter.format(price / 100).replace(/\.00/g, '')
  }
  return formatter.format(price / 100)
}

export let dollarsToCents = function (value) {
  if (value == null || value === "") return null;

  // Make sure it's a string, strip out $, commas, spaces, etc.
  const cleaned = String(value).replace(/[^0-9.]/g, "");
  const num = parseFloat(cleaned);
  if (Number.isNaN(num)) return null;

  return Math.round(num * 100);
}


export let validateAddresses = function (input, output) {
  let outZip = output.zip.substring(0, 5)

  return (
    input.address.toLowerCase() === output.address.toLowerCase() &&
    input.city.toLowerCase() === output.city.toLowerCase() &&
    input.state.toLowerCase() === output.state.toLowerCase() &&
    input.zip.startsWith(outZip)
  )
}

export let scrollToY = function (pos) {
  document.body.scrollTop = pos // For Safari
  document.documentElement.scrollTop = pos // For Chrome, Firefox, IE and Opera
}

// mostly used for URL formatting except for the Subscription Options
export let formatTitle = function (title) {
  // replaceAll is for newer browsers
  return title.replace(/ /g, '-').replace(/\//g, '-').replace('?', '')
}

export function formatDuration(seconds) {
  const totalSeconds = Math.floor(seconds);

  const secondsPerDay = 86400;
  const secondsPerMonth = 30.44 * secondsPerDay;
  const secondsPerYear = 365.25 * secondsPerDay;

  let remaining = totalSeconds;

  const years = Math.floor(remaining / secondsPerYear);
  remaining %= secondsPerYear;

  const months = Math.floor(remaining / secondsPerMonth);
  remaining %= secondsPerMonth;

  const days = Math.floor(remaining / secondsPerDay);
  remaining %= secondsPerDay;

  const parts = [];
  if (years) parts.push(`${years}y`);
  if (months) parts.push(`${months}mo`);
  if (days) parts.push(`${days}d`);
  if (parts.length === 0) parts.push(`${String(secs).padStart(2, '0')}s`);

  return parts.join(' ');
}
